<template>
  <router-view></router-view>
</template>

<script>
import axios from "axios";

export default {
  name: "app",

  created: function () {
    document.title = this.$store.getters.config.company + '. ' + this.$t('auth.title')

    axios.interceptors.response.use(undefined, async (error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        error.response.config &&
        !error.response.config.__isRetryRequest
      ) {
        await this.$store.dispatch("authLogout");
        if (this.$route.path !== "/login") {
          localStorage.setItem("lastUrl", this.$route.path);
        }
        this.$router.push("/login");
      }
      throw error;
    });

    // Обработка авторизации через url-параметр токен
    // const token = this.$route.query.token;

    // if (token !== undefined) {

    //   axios.defaults.headers.common['Authorization'] = token;

    //   console.log("axios.defaults", axios.defaults);

    //   this.getUserRoleItem();
    //   this.$router.push(this.$route.path);
    // }
  },
};
</script>
